import React, { useEffect } from "react"
import { Route, withRouter, useHistory, useLocation } from "react-router-dom"
import { useAuth0 } from "../react-auth0-wrapper"
import { connect } from "react-redux"
import { fetchUserGameDetails, acceptTeamInvite } from "../lib/apiServices"
import { saveTokenToState } from "../actions"
import PbgThemeProvider from "./ThemeProvider"
import Loading from "./Loading"

const mapStateToProps = (state) => ({
  token: state.token || null,
})

const PrivateRoute = ({ component: Component, path, ...rest }) => {
  const { token, dispatch } = rest
  const {
    loading,
    isAuthenticated,
    loginWithRedirect,
    getTokenSilently,
  } = useAuth0()

  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const saveToken = async () => {
      const authToken = await getTokenSilently()
      if (authToken !== token) {
        dispatch(saveTokenToState(authToken))
        // handle invites
        const queryParams = new URLSearchParams(location.search)
        if (queryParams.has("inviteLinkUuid")) {
          dispatch(acceptTeamInvite(authToken, queryParams.get("inviteLinkUuid")))
          queryParams.delete("inviteLinkUuid")
          history.replace({
            search: queryParams.toString(),
          })
        }
        dispatch(fetchUserGameDetails(authToken))
      }
    }

    if (loading) {
      return (
        <PbgThemeProvider>
          <Loading />
        </PbgThemeProvider>
      )
    } else if (isAuthenticated) {
      saveToken()
      return
    }
    const fn = async () => {
      await loginWithRedirect({
        appState: { targetUrl: window.location.pathname },
      })
    }
    fn()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loading,
    isAuthenticated,
    loginWithRedirect,
    path,
    token,
    dispatch,
    getTokenSilently,
    location.search
  ])

  const render = (props) =>
    isAuthenticated === true ? <Component {...props} /> : null

  return <Route path={path} render={render} {...rest} />
}

export default withRouter(connect(mapStateToProps)(PrivateRoute))
